var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8887 7.6665H43.4443C49.0899 7.6665 53.6665 12.2431 53.6665 17.8887C53.6665 23.5343 49.0899 28.111 43.4443 28.111H17.8887C12.2431 28.111 7.6665 23.5343 7.6665 17.8887C7.6665 12.2431 12.2431 7.6665 17.8887 7.6665ZM17.8887 22.9998C20.7115 22.9998 22.9998 20.7115 22.9998 17.8887C22.9998 15.0659 20.7115 12.7776 17.8887 12.7776C15.0659 12.7776 12.7776 15.0659 12.7776 17.8887C12.7776 20.7115 15.0659 22.9998 17.8887 22.9998Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8887 33.2222H43.4443C49.0899 33.2222 53.6665 37.7988 53.6665 43.4444C53.6665 49.09 49.0899 53.6666 43.4443 53.6666H17.8887C12.2431 53.6666 7.6665 49.09 7.6665 43.4444C7.6665 37.7988 12.2431 33.2222 17.8887 33.2222ZM43.4443 48.5555C46.2671 48.5555 48.5554 46.2672 48.5554 43.4444C48.5554 40.6216 46.2671 38.3333 43.4443 38.3333C40.6215 38.3333 38.3332 40.6216 38.3332 43.4444C38.3332 46.2672 40.6215 48.5555 43.4443 48.5555Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.eea431d7d7ca11cf01e76dafba96abd9.svg";
export { ForwardRef as ReactComponent };